if (!customElements.get('slava-carousel')) {
  customElements.define('slava-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('.v3-track');
      if (!this.track) return;
      this.buttons = this.querySelectorAll('[data-direction]');
      this.buttons.forEach(button => button.addEventListener('click', () => this.move(Number(button.dataset.direction))));
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') {
          this.scroll(event.key === 'Home' ? 0 : this.maximum());
        } else {
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      this.track.addEventListener('pointerdown', event => {
        if (!event.isPrimary || event.button > 0) return;
        this.pointerStart = {x: event.clientX, y: event.clientY, left: this.track.scrollLeft, id: event.pointerId};
        this.dragging = false;
        this.suppressClick = false;
      });
      this.track.addEventListener('pointermove', event => {
        const start = this.pointerStart;
        if (!start || start.id !== event.pointerId) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (!this.dragging && (Math.abs(dx) < 8 || Math.abs(dx) <= Math.abs(dy))) return;
        if (!this.dragging) {
          this.dragging = true;
          this.track.classList.add('v3-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        this.track.scrollLeft = Math.max(0, Math.min(this.maximum(), start.left - dx));
        if (event.cancelable) event.preventDefault();
      });
      const finishDrag = event => {
        if (!this.pointerStart || this.pointerStart.id !== event.pointerId) return;
        const card = this.track.querySelector('.v3-card');
        const step = card ? card.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0) : 1;
        const position = this.track.scrollLeft;
        if (this.dragging) this.suppressClick = true;
        this.track.classList.remove('v3-dragging');
        if (this.dragging) this.scroll(Math.round(position / step) * step);
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        this.pointerStart = null;
        this.dragging = false;
      };
      this.track.addEventListener('pointerup', finishDrag);
      this.track.addEventListener('pointercancel', finishDrag);
      this.track.addEventListener('click', event => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }, true);
      this.track.addEventListener('dragstart', event => event.preventDefault());
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
    maximum() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
    scroll(left) {
      this.track.scrollTo({left, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    move(direction) {
      const card = this.track.querySelector('.v3-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const max = this.maximum();
      let left = this.track.scrollLeft + direction * step;
      if (direction > 0 && this.track.scrollLeft >= max - 2) left = 0;
      if (direction < 0 && this.track.scrollLeft <= 2) left = max;
      this.scroll(Math.max(0, Math.min(max, left)));
    }
    update() {
      const canScroll = this.maximum() > 2;
      this.buttons.forEach(button => {button.disabled = !canScroll;});
    }
  });
}
document.addEventListener('click', event => {
  document.querySelectorAll('.v3-nav-menu[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.v3-nav-menu[open]').forEach(menu => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});
